// MUI
import { Stack, Typography } from "@mui/material";

// Components
import BasicInformationTable from "@DataPages/components/Inventory/Tables/Reconciliation/SummaryTable/BasicInformationTable";
import CommonInformationTable from "@DataPages/components/Inventory/Tables/Reconciliation/SummaryTable/CommonInformationTable";
import NewVehicleInformationTable from "@DataPages/components/Inventory/Tables/Reconciliation/SummaryTable/NewVehicleInformationTable";

// Types
import { ISummaryDetail } from "@DataPages/types/inventory/models/reconciliation";
import { TCapitalizedVehicleType } from "@DataPages/types/inventory/commons";

type SummaryTableProps = Readonly<{
	title: string;
	vehicleType: TCapitalizedVehicleType;
	data: ISummaryDetail;
}>;

export default function SummaryTable(props: SummaryTableProps) {
	return (
		<Stack component={"article"}>
			<Typography component={"h4"} className="!font-montserrat !text-default !font-medium !text-xl">
				{props.title}
			</Typography>
			<BasicInformationTable data={props.data} />
			<CommonInformationTable data={props.data} />
			{props.vehicleType === "New" && <NewVehicleInformationTable data={props.data} />}
		</Stack>
	);
}
